import { render, staticRenderFns } from "./ImportHistoriesTable.vue?vue&type=template&id=05211f3b&scoped=true"
import script from "./ImportHistoriesTable.vue?vue&type=script&lang=js"
export * from "./ImportHistoriesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05211f3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05211f3b')) {
      api.createRecord('05211f3b', component.options)
    } else {
      api.reload('05211f3b', component.options)
    }
    module.hot.accept("./ImportHistoriesTable.vue?vue&type=template&id=05211f3b&scoped=true", function () {
      api.rerender('05211f3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/ImportHistoriesTable.vue"
export default component.exports